import React, { useEffect, useRef } from "react";
import "./sidePanel.css";
import { SidePanel } from '@kui-react/side-panel'
import { ProductListContext } from "../../context/ProductListContext";
const SideMenu = ({ tabData, onClickOutside,switchtabs,etailCall,ButtonText}) => {
  const tabList = tabData;
  let productState = React.useContext(ProductListContext);
  const { isOpen, setIsOpen, activeTab, setActiveTab } = productState;
  const reactQuillRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        reactQuillRef.current &&
        !reactQuillRef.current.contains(event.target)
      ) {
        setIsOpen(false);
        onClickOutside && onClickOutside();
      }
    };
    document.body.addEventListener("click", handleClickOutside, true);
    return () => {
      document.body.removeEventListener("click", handleClickOutside, true);
    };
    // eslint-disable-next-line
  }, [onClickOutside]);

  return (
    <div ref={reactQuillRef}>
      <SidePanel
        onClose={() => setIsOpen(false)}
        open={isOpen}
        title={ButtonText}
      >
        <ul>
          {" "}
          {tabList && tabList.length > 0 && activeTab
            ? tabList.map((tab, index) => {
                return (
                  tab?.active&& (
                    <li
                      onClick={() => {
                        etailCall("PAGE_CLICK", tab)
                        setActiveTab(tab);
                        switchtabs(tab.tbId);
                        setIsOpen(false); 
                      }}
                      key={tab.name + "_" + index}
                      role="button"
                      aria-label="Tab"
                      className={
                        "nv-navItem " +
                        (tab?.tbId === activeTab?.tbId
                          ? " nv-activeSideNav"
                          : "")
                      }
                    >
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a>
                        <span>{tab.name}</span>
                        <span className=""></span>
                      </a>
                    </li>
                  )
                );
              })
            : null}
        </ul>
      </SidePanel>
    </div>
  );
};

export default SideMenu;
